import { render, staticRenderFns } from "./FormPage.vue?vue&type=template&id=4ce18a06&"
import script from "./FormPage.vue?vue&type=script&lang=ts&"
export * from "./FormPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4ce18a06')) {
      api.createRecord('4ce18a06', component.options)
    } else {
      api.reload('4ce18a06', component.options)
    }
    module.hot.accept("./FormPage.vue?vue&type=template&id=4ce18a06&", function () {
      api.rerender('4ce18a06', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/account-receivables/invoice-prepayment/FormPage.vue"
export default component.exports